// Copyright (c) 2016 Deere & Company

import AppContainer from './app-container';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = (state, ownProps) => ({
    alertMessages: state.alertMessages,
    appConfig: state.appConfig,
    children: ownProps.children,
    constants: {
        allClaimTypes: Array.concat(state.app.claimTypes, state.app.subClaimTypes),
        claimTypes: state.app.claimTypes,
        subClaimTypes: state.app.subClaimTypes
    },
    isSapUp: state.app.sapStatus.isSapUp,
    links: state.app.links,
    location: ownProps.location,
    params: ownProps.params,
    routes: ownProps.routes,
    security: state.user.security,
    sessionExpiredModalVisibility: state.app.sessionExpiredModalVisibility,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AppContainer);



// WEBPACK FOOTER //
// ./src/app/state-connector.js